module.exports = __webpack_public_path__ + "static/media/0324_IMG_LE_CHARCUTIER.c1bb88e8.webp";